import { useEffect } from 'react';
import { useRouter as useNextRouter } from 'next/navigation';
import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import useRedirect from '~/client/hooks/router/useRedirect';
import useRouter from '~/client/hooks/router/useRouter';
import useIsLoggedIn from '~/client/hooks/user/useIsLoggedIn';
import useSite from '~/client/hooks/useSite';
import useParseExternalHref from '~/client/shared/NextLink/useNextLink/useParseExternalHref';

const usePlayGame = () => {
  const isLoggedIn = useIsLoggedIn();
  const { isBridgeSite } = useSite();
  const { asPath, replace } = useRouter();
  const router = useNextRouter();
  const { parseExternalHref } = useParseExternalHref();
  const { game, startSession, gameSession, inGameCurrency, loadingSession } =
    useGameContext();
  const canPlayFunMode = game?.hasFunMode;
  const { redirect } = useRedirect();

  const handlePlayForReal = () => {
    if (!isLoggedIn) {
      if (isBridgeSite) {
        replace(`${asPath}?c=home`);
        redirect(parseExternalHref('/register'), 'replace');
      }
      const registerRef = `/register?redirect=${asPath}?c=home`;
      redirect(registerRef, 'replace');
    } else {
      startSession({ isFunMode: false, inGameCurrency });
    }
  };

  const handlePlayForFun = () => {
    startSession({ isFunMode: true });
  };

  useEffect(() => {
    if (gameSession?.url) {
      router.push(gameSession.url);
    }
  }, [gameSession?.url, router]);

  return {
    canPlayFunMode,
    handlePlayForReal,
    handlePlayForFun,
    loadingSession,
  };
};

export default usePlayGame;
